import * as React from 'react';
import { Paper, Divider, List, ListSubheader, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Menu, MenuItem } from '@mui/material';
import { MoreVert as MoreVertIcon, Add } from '@mui/icons-material';
import { serviceLocator } from '../../services';
import { confirmDialog, notify } from '../../services/ui-dialog';
import { Formik, FastField } from 'formik';
import * as Yup from 'yup';

import { FormikTextField } from '../FormikTextField';
import { ListSubheaderWithButtons } from '../ListSubheaderWithButtons';

interface Props {
    websiteKey: string,
    paperProps?: any;
}

interface State {
    items: string[];
    openDialog: string | null;
    cloneKey: string | null;
    itemMenuOpen: boolean;
    menuAnchor: any;
    menuItemKey: string;

}

const dialogContentStyle: any = {
    minWidth: '300px'
}
const validPageName = /^[a-z0-9-]+$/;

export class AliasesList extends React.Component<Props, State>{

    state: State = {
        items: [],
        cloneKey: null,
        itemMenuOpen: false,
        menuAnchor: null,
        menuItemKey: '',
        openDialog: null
    }

    componentDidMount = async () => {
        this.loadItems();
    }

    async loadItems() {
        const items = await serviceLocator.getWebsiteService().getAliases(this.props.websiteKey);
        this.setState({ items });
    }

    handleCollectionItemMoreClick = (e: any) => {
        const target = e.currentTarget;
        this.setState({ itemMenuOpen: true, menuAnchor: target, menuItemKey: target.dataset.key });
    }

    private handleMenuClose = (e: any) => {
        this.setState({ itemMenuOpen: false });
    }

    private handleNewClick = (e: any) => {
        this.setState({ openDialog: 'new' });
    }

    handleNewItemFormSubmit = async (values: any, { setSubmitting, resetForm }: any) => {
        try {
            if (values.fromName) {
                //await serviceLocator.getWebsiteService().cloneCollectionItem(this.props.website, "pages", values.fromName, values.name );
            }
            else {
                await serviceLocator.getWebsiteService().putAlias(this.props.websiteKey, values.name);
            }

            setSubmitting(false);
            resetForm();
            this.setState({ openDialog: '', cloneKey: null });
            this.loadItems();
        }
        catch{
            setSubmitting(false);
            notify({ message: 'An error occurred while saving.', severity: 'error' });
        }
    }

    handleDialogClose = () => {
        this.setState({ openDialog: '' });
    }

    handleItemDelete = async (e: any) => {
        const itemKey = this.state.menuItemKey;
        this.setState({ itemMenuOpen: false });
        const ok = await confirmDialog({
            title: `Delete alias "${itemKey}"?`,
            message: 'This cannot be undone from the UI.',
            confirmLabel: 'Delete',
            severity: 'error',
        });
        if (ok) {
            await serviceLocator.getWebsiteService().deleteAlias(this.props.websiteKey, itemKey);
            this.loadItems();
        }
    }

    renderMenu() {
        return (
            <Menu
                key="page-menu"
                open={this.state.itemMenuOpen}
                anchorEl={this.state.menuAnchor}
                onClose={this.handleMenuClose}
            >
                {/* <MenuItem onClick={this.handleItemClone} >Clone</MenuItem> */}
                <MenuItem onClick={this.handleItemDelete} >Delete</MenuItem>
            </Menu>
        );
    }

    renderDialog() {
        return (
            <Formik
                key={this.state.cloneKey || 'new'}
                initialValues={{ name: '', fromName: this.state.cloneKey || '' }}
                onSubmit={this.handleNewItemFormSubmit}
                validationSchema={
                    Yup.object().shape({
                        name: Yup.string().matches(validPageName, "Invalid alias").required('Required.')
                    }).required()
                }>
                {props => {
                    const { handleSubmit, isSubmitting, submitForm } = props;

                    return (
                        <Dialog
                            onClose={this.handleDialogClose}
                            open={this.state.openDialog === 'new'}>
                            <DialogTitle style={dialogContentStyle}>{this.state.cloneKey ? `Clone Page "${this.state.cloneKey}"` : 'Create Alias'}</DialogTitle>
                            <DialogContent style={dialogContentStyle}>
                                <form onSubmit={handleSubmit}>
                                    <FastField autoFocus={true} debounce={15} margin="normal" name="name" label="Alias" component={FormikTextField} />
                                    <button disabled={isSubmitting} type="submit" onClick={submitForm} style={{ width: 1, height: 1, visibility: 'hidden' }}>Create</button>
                                </form>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    disabled={isSubmitting}
                                    color="primary"
                                    type="submit"
                                    value="create"
                                    onClick={submitForm}>Create</Button>
                            </DialogActions>
                        </Dialog>
                    )
                }}
            </Formik>
        );
    }

    renderList() {
        return (
            <List component="nav" subheader={<ListSubheaderWithButtons onNewClick={this.handleNewClick} title={`Aliases`} />}>
                <Divider />
                {(this.state.items || []).map((item, i) => {
                    return (
                        <ListItem key={item}
                            divider={true}>
                            <ListItemText primary={item} />
                            <ListItemSecondaryAction>
                                <IconButton onClick={this.handleCollectionItemMoreClick} data-key={item} size="large">
                                    <MoreVertIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    );
                })}
            </List>
        );
    }

    render() {
        return (
            <Paper {...this.props.paperProps}>
                {this.renderList()}
                {this.renderDialog()}
                {this.renderMenu()}
            </Paper>
        )
    }
}